__turbopack_context__.v({
  "brand": "vk6HdW_brand",
  "cardSubtext": "vk6HdW_cardSubtext",
  "container": "vk6HdW_container",
  "content": "vk6HdW_content",
  "copy": "vk6HdW_copy",
  "dialogue": "vk6HdW_dialogue",
  "error": "vk6HdW_error",
  "forgotPassword": "vk6HdW_forgotPassword",
  "form": "vk6HdW_form",
  "headerIcon": "vk6HdW_headerIcon",
  "heading": "vk6HdW_heading",
  "icon": "vk6HdW_icon",
  "input": "vk6HdW_input",
  "intro": "vk6HdW_intro",
  "noAccount": "vk6HdW_noAccount",
  "submitButton": "vk6HdW_submitButton",
  "subtext": "vk6HdW_subtext",
});
